function findClosest(numbers, target) {
  if (!Array.isArray(numbers) || numbers.length === 0) {
    throw new Error("Input must be a non-empty array");
  }
  if (typeof target !== "number" || isNaN(target)) {
    throw new Error("Target must be a valid number");
  }

  if (numbers.length === 1) {
    return numbers[0];
  }

  return numbers.reduce((closest, current) => {
    const currentDiff = Math.abs(target - current);
    const closestDiff = Math.abs(target - closest);
    return currentDiff < closestDiff ? current : closest;
  });
}

module.exports = findClosest;
